var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-right mr-2 ml-auto mt-auto mb-auto"},[_vm._v(_vm._s(_vm.version))])
}
var staticRenderFns = []

export { render, staticRenderFns }